import React from "react";
import { Spinner } from "react-bootstrap";

export default function Loading() {
  return (
    <div className="text-center" style={{ marginTop: "15%" }}>
      <div style={{ fontSize: 20 }}>
        Cargando
      </div>
      <div className="d-flex justify-content-center mt-4" style={{ gap: 5 }}>
        <Spinner animation="grow" size="sm" className="spinner-grow-1" />
        <Spinner animation="grow" size="sm" className="spinner-grow-2" />
        <Spinner animation="grow" size="sm" className="spinner-grow-3" />
      </div>
    </div>
  );
}
